import { createSlice } from '@reduxjs/toolkit';
import { fetchTaskSheetSummary, fetchTaskSheetDetail, fetchMyStats } from '../actions/taskSheetActions';
import { TaskSheetState } from '../types/taskSheetTypes';

const initialState: TaskSheetState = {
  summaries: [],
  loadingSummaries: false,
  employee: null,
  stats: null,
  projects: [],
  pagination: null,
  loadingDetail: false,
  error: null,
  dateRange: null,
  myStats: null,
  loadingMyStats: false,
};

const taskSheetSlice = createSlice({
  name: 'taskSheet',
  initialState,
  reducers: {
    clearTaskSheetDetail(state) {
      state.employee = null;
      state.stats = null;
      state.projects = [];
      state.pagination = null;
      state.loadingDetail = false;
      state.error = null;
    },
    clearTaskSheetError(state) {
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchTaskSheetSummary.pending, state => {
        state.loadingSummaries = true;
        state.error = null;
      })
      .addCase(fetchTaskSheetSummary.fulfilled, (state, action) => {
        state.loadingSummaries = false;
        state.summaries = action.payload.data || [];
        state.dateRange = action.payload.dateRange || null;
      })
      .addCase(fetchTaskSheetSummary.rejected, (state, action) => {
        state.loadingSummaries = false;
        state.error = (action.payload as string) || 'Failed to fetch summaries';
      });

    builder
      .addCase(fetchTaskSheetDetail.pending, state => {
        state.loadingDetail = true;
        state.error = null;
      })
      .addCase(fetchTaskSheetDetail.fulfilled, (state, action) => {
        state.loadingDetail = false;
        state.employee = action.payload.employee || null;
        state.stats = action.payload.stats || null;
        state.projects = action.payload.data || [];
        state.pagination = action.payload.pagination || null;
      })
      .addCase(fetchTaskSheetDetail.rejected, (state, action) => {
        state.loadingDetail = false;
        state.error = (action.payload as string) || 'Failed to fetch task sheet detail';
      });

    builder
      .addCase(fetchMyStats.pending, state => {
        state.loadingMyStats = true;
      })
      .addCase(fetchMyStats.fulfilled, (state, action) => {
        state.loadingMyStats = false;
        state.myStats = action.payload.stats || null;
      })
      .addCase(fetchMyStats.rejected, state => {
        state.loadingMyStats = false;
      });
  },
});

export const { clearTaskSheetDetail, clearTaskSheetError } = taskSheetSlice.actions;
export default taskSheetSlice.reducer;
